import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import {SchoolLayer} from "../components/manger/SchoolLayer";

export const SchoolPage = () => {
  return (
    <MasterLayout>
      <SchoolLayer />
    </MasterLayout>
  );
};
